<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()" aria-label="Close"></button>
</div>
<div class="modal-body">
    <div class="container-fluid">
        <div class="d-grid gap-3">
        @for (item of injectContent; track item.content) {
            @if (item.injectType === INJECT_TYPE.COMPONENT) {
                <ng-container *ngComponentOutlet="item.content; inputs: item.data"/>
            } @else {
                <ng-container [ngTemplateOutlet]="$any(item.content)" [ngTemplateOutletContext]="{ $implicit: item.data }" />
            }
        }
        </div>
        <div class="d-grid grid-6 gap-3 justify-content-center" appNoRightClick>
        @for (f of fileArr(); track f; let i = $index) {
            <div class="image-wrapper">
                <div class="image-box" (click)="f.fileType === FILE_TYPE.IMAGE ? openEnlargeImageModal(i) : previewFile(f.url)">
                    <span class="badge text-bg-dark date-tag" #tooltip="matTooltip" [matTooltip]="f.lastModified" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black">{{ f.lastModified | date: "dd-MM-yyyy" }}</span>
                @switch(f.fileType) {
                    @case (FILE_TYPE.IMAGE) {
                        <img [src]="f.data" />
                    }
                    @case (FILE_TYPE.PDF) {
                        <h1><i class="fas fa-file-pdf"></i></h1>
                    }
                    @case (FILE_TYPE.VIDEO) {
                        <h1><i class="fas fa-video"></i></h1>
                    }
                    @default {
                        <h1><i class="fas fa-file"></i></h1>
                    }
                }
                @if (canDelete && [FILE_TYPE.PDF, FILE_TYPE.VIDEO].includes(f.fileType)) { <button appStopPropagation class="bottom-right btn btn-outline-danger" (click)="deleteFile(f.url)"><i class="fas fa-trash-alt"></i></button> }
                </div>
                <p class="download-link" [title]="f.label" (click)="downloadFile(f.url, f.label)">{{ f.label }}</p>
            </div>
        }
        </div>
    </div>
</div>